import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as CannedResponseIcon } from "../../../assets/svg/canned-response-icon.svg";
import { ReactComponent as cannedResponse } from "../../../assets/svg/canned-response-icon.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const SMRCannedResponse = () => {
    const dispatch = useDispatch();
    // useEffect(() => {
    //     let obj = {
    //         // total_sections: 33,
    //         progress_config: {
    //             smr_canned_response: 1,
    //         },
    //     };

    //     dispatch(configure_getting_started_progress(obj));
    // }, []);
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                smr_canned_response: 1,
            },
        };
        localStorage.setItem("activeModule", "Response");
        dispatch(setActiveModule("Response"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <CannedResponseIcon className="icon_content fill_svg" />
                        <span className="content_title">Response Canned Responses</span>
                    </div>
                    <div className="text_content">
                        <p>{`In this section, you can create standard responses that the agents can use.`}</p>
                        <p>{`Your agents might be responding to standard queries with a standard response or customizing some standard responses for a user.  Instead of typing everything from scratch, just create a list of standard responses and use them again and again!  This will save time and improve your agent productivity.`}</p>
                        <p>{`What’s more, just type “/” in the response box and the canned responses pop up saving you even more time 😊`}</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/social-response/canned">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/HIHLXETbXbc"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default SMRCannedResponse;
